var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.465,
    height: 68.33,
    viewBox: "0 0 65.465 68.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5405",
    "data-name": "Group 5405",
    transform: "translate(-678 -544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accept",
    transform: "translate(678 544.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M75.707,98.637H63.759a2,2,0,1,0,0,4H75.707a2,2,0,1,0,0-4Zm0,0",
    transform: "translate(-53.516 -85.474)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    "data-name": "Path 3136",
    d: "M75.707,158.641H63.759a2,2,0,1,0,0,4H75.707a2,2,0,1,0,0-4Zm0,0",
    transform: "translate(-53.516 -137.47)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    "data-name": "Path 3137",
    d: "M75.707,218.645H63.759a2,2,0,0,0,0,4H75.707a2,2,0,0,0,0-4Zm0,0",
    transform: "translate(-53.516 -189.466)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3138",
    "data-name": "Path 3138",
    d: "M75.707,278.648H63.759a2,2,0,0,0,0,4H75.707a2,2,0,1,0,0-4Zm0,0",
    transform: "translate(-53.516 -241.461)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3139",
    "data-name": "Path 3139",
    d: "M75.707,339.656H63.759a2,2,0,1,0,0,4H75.707a2,2,0,1,0,0-4Zm0,0",
    transform: "translate(-53.516 -294.327)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    "data-name": "Path 3140",
    d: "M203.658,102.641h11.948a2,2,0,1,0,0-4H203.658a2,2,0,1,0,0,4Zm0,0",
    transform: "translate(-174.744 -85.474)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    "data-name": "Path 3141",
    d: "M203.658,162.645h11.948a2,2,0,1,0,0-4H203.658a2,2,0,1,0,0,4Zm0,0",
    transform: "translate(-174.744 -137.47)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M211.414,220.647a2,2,0,0,0-2-2h-5.754a2,2,0,1,0,0,4h5.754A2,2,0,0,0,211.414,220.647Zm0,0",
    transform: "translate(-174.743 -189.466)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M323.771,343.128a2,2,0,0,0-2.814.309l-5.156,6.428-3.192-2.313a2,2,0,1,0-2.349,3.242l4.735,3.431a2,2,0,0,0,2.736-.369l6.349-7.914A2,2,0,0,0,323.771,343.128Zm0,0",
    transform: "translate(-268.136 -296.954)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M60.694,40.029a16.509,16.509,0,0,0-9.589-4.819V8.061A8.072,8.072,0,0,0,43.044,0H8.063A8.072,8.072,0,0,0,0,8.061V54.434A8.072,8.072,0,0,0,8.062,62.5H36.2A16.479,16.479,0,0,0,48.84,68.329a16.639,16.639,0,0,0,11.854-28.3ZM4,54.434V8.061A4.064,4.064,0,0,1,8.063,4H43.044A4.063,4.063,0,0,1,47.1,8.061V35.146A16.648,16.648,0,0,0,33.663,58.492H8.063A4.063,4.063,0,0,1,4,54.434ZM48.84,64.326a12.633,12.633,0,0,1,0-25.266l.2,0h.031a12.633,12.633,0,0,1-.228,25.264Zm0,0",
    fill: "#90205d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsConditions);
export default __webpack_public_path__ + "static/media/termsConditions.18c997ea.svg";
export { ForwardRef as ReactComponent };